import { render, staticRenderFns } from "./reporte.vue?vue&type=template&id=ef06af52"
import script from "./reporte.vue?vue&type=script&lang=js"
export * from "./reporte.vue?vue&type=script&lang=js"
import style0 from "./reporte.vue?vue&type=style&index=0&id=ef06af52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports